module Meevo.Components.ScrollableLocationSelector {
    export class ScrollableLocationSelectorController {

        static $inject = [
            "meevo.components.locationPicker.LocationPickerService"
        ];

        public location: any;
        public isLoaded = true;
        public criteria = {
            filterBySessionUser: true,
            locationStatus: [Meevo.Model.LocationStatusEnum.Active, Meevo.Model.LocationStatusEnum.ClosingPlanned, Meevo.Model.LocationStatusEnum.TemporarilyClosed],
            subscriptionStatus: [Meevo.Model.SubscriptionStatusEnum.Active]
        };

        constructor(private locationPickerService: Meevo.Components.LocationPicker.ILocationPickerService) {
        }

        locationChanged() {
            if (this.location && this.location.locationId) {
                this.locationPickerService.switchLocation(this.location.locationId)
            }
        }
    }

    angular.module("meevo.components.scrollableLocationSelector")
    .controller("meevo.components.scrollableLocationSelector.ScrollableLocationSelectorController", ScrollableLocationSelectorController);
}

